export default __webpack_public_path__ + "static/2-75df2dc868f8db816472d763cc797c14.jpeg";